import tw from 'twin.macro';
import styled from 'styled-components';
import { ChaseMenuStylesProps } from './ChaseMenuItem.types';

export const ChaseMenuItemContainer = styled.div<ChaseMenuStylesProps>`
  ${tw`
        relative
        flex
        flex-col
        items-center
        justify-center
        w-[3rem]
        h-[3rem]
        rounded-full
        p-4
        cursor-pointer
        transition-all
        duration-300
        ease-in-out

    `};
  ${({ active }) =>
    active &&
    tw`bg-yellow [&>div]:-top-2 [&>div]:[&>p]:opacity-100 
       [&>div]:[&>img]:h-[35px] [&>div]:[&>img]:w-[35px] [&>div]:[&>img]:grayscale-0`}
`;

export const ChaseMenuItemContent = tw.div`w-full h-full absolute -top-0.5 flex flex-col items-center justify-between gap-1.5 [&>p]:opacity-[0.48]`;

export const ChaseMenuItemImage = tw.img`w-[28px] h-[28px] rounded-full object-cover object-center grayscale`;
